import keyframes from './Growl.keyframes.css';

const colors = {
  action: '#0C7C84',
  error: '#D32F2F',
  info: '#3B44A9',
  neutralGray: '#424242',
  neutralGrayAlt: '#757575',
  neutralWhite: '#FFFFFF',
  shadow: 'rgba(0%, 0%, 0%, .16)',
  subduedGray: '#6B6B6B',
  success: '#4CAF51',
};
const flexboxLayouts = {
  default: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  column: {
    flexDirection: 'column',
  },
  centerAll: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  centerFlexEnd: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  flexStartAll: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
};
const spacing = {
  default: 12,
  action: 8,
  stacking: 12,
};
const typography = {
  default: {
    color: colors.neutralGray,
    fontSize: '14px',
    fontFamily: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif',
  },
  action: {
    color: colors.action,
    fontWeight: 400,
    textTransform: 'uppercase',
  },
  actionResult: {
    fontWeight: 400,
    textTransform: 'uppercase',
  },
  close: {
    color: colors.neutralGrayAlt,
    fontSize: '12px',
  }
};

const closeAnimationSecondsAutomatic = 0.4;
const closeAnimationSecondsForced = .25;
const openAnimationSeconds = 0.4;
const totalMinHeightPixels = 56;
const totalWidthPixels = 350;
const badgePixels = 32;
const closeButtonWidthPixels = 12;
const bodyWidth = totalWidthPixels - (badgePixels + (spacing.default * 2) + closeButtonWidthPixels);

export {
  closeAnimationSecondsAutomatic,
  closeAnimationSecondsForced,
  openAnimationSeconds,
};

let styles = {
  action: {
    ...typography.action,
    marginLeft: '20px',
    cursor: 'pointer',
  },
  actionContainer: {
    ...flexboxLayouts.centerFlexEnd,
    width: '100%',
    paddingTop: `${spacing.action}px`,
  },
  actionResult: {
    ...typography.actionResult,
  },
  badgeContainer: {
    ...flexboxLayouts.centerAll,
    width: `${badgePixels}px`,
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  badgeIcon: {
    ...flexboxLayouts.centerAll,
    height: `${badgePixels}px`,
    width: `${badgePixels}px`,
  },
  body: {
    ...flexboxLayouts.flexStartAll,
    ...flexboxLayouts.column,
    ...typography.default,
    width: `${bodyWidth}px`,
    paddingLeft: `${spacing.default}px`,
    paddingRight: `${spacing.default}px`,
    backgroundColor: colors.neutralWhite,
    userSelect: 'none',
    verticalAlign: 'middle',
  },
  closeAnimation: {
    calculate(durationSeconds) {
      return {
        animationName: keyframes.close,
        animationDuration: `${durationSeconds}s`,
        animationTimingFunction: 'ease',
        animationFillMode: 'forwards',
      };
    },
  },
  closeButton: {
    ...typography.close,
    position: 'absolute',
    top: `${spacing.default/2}px`,
    right: `${spacing.default}px`,
    cursor: 'pointer',
  },
  container: {
    calculate(status) {
      return {
        ...flexboxLayouts.default,
        position: 'relative',
        minHeight: `${totalMinHeightPixels}px`,
        width: `${totalWidthPixels}px`,
        padding: `${spacing.default}px`,
        borderLeft: `solid 8px ${colors[status]}`,
        boxShadow: `0 3px 3px 0 ${colors.shadow}`,
        backgroundColor: colors.neutralWhite,
        color: colors[status],
        fill: colors[status]
      };
    },
  },
  contextContainer: {
    color: colors.subduedGray,
    paddingBottom: '12px',
    textOverflow: 'ellipsis',
    width: '100%',
    minWidth: '0px',
    overflow: 'hidden',
  },
  openAnimation: {
    calculate(durationSeconds) {
      return {
        animationName: keyframes.open,
        animationDuration: `${durationSeconds}s`,
        animationTimingFunction: 'ease',
      };
    },
  },
  spacer: {
    height: `${spacing.stacking}px`,
  },
};

export default styles;
